import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../../common/method/handleNotificationAlert'


export const actionTypes = {
    selectMarkowitsSymbol: "selectMarkowitsSymbol [Action]",
    selectMarkowitsSymbolLoading: "selectMarkowitsSymbolLoading [Action]",
    selectMarkowitsSymbolAsync: "selectMarkowitsSymbolAsync [Action]",
    selectMarkowitsSymbolClear: "selectMarkowitsSymbolAsync [Action]",
};
const inistiaState = {
    data: [],
    loading: false,
    total:0
};

export const selectMarkowitsSymbolReducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectMarkowitsSymbol:
            return {
                ...state,
                data: payload?.results,
                total: payload?.total,
            };
        case actionTypes.selectMarkowitsSymbolLoading:
            return {
                ...state,
                loading: payload,
            };
        case actionTypes.selectMarkowitsSymbolClear:
            return {
                ...inistiaState,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectMarkowitsSymbolLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "select_markowitz_valid_symbols",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectMarkowitsSymbol, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectMarkowitsSymbolLoading, payload: false })

    }
}

export function* selectMarkowitsSymbol() {
    yield takeLatest(actionTypes.selectMarkowitsSymbolAsync, handleWorker);
}
